module.exports = __webpack_public_path__ + "static/media/OpenSansHebrew-Bold.27a6a1f1.ttf";